import { useEffect, useState } from "react";

export default function OnlineStatusBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  const [showOnlineBanner, setShowOnlineBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      setShowOnlineBanner(true);
      setTimeout(() => setShowOnlineBanner(false), 1000); // hide after 1s
    };

    const handleOffline = () => {
      setOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!online) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: "#ff4d4f",
          color: "white",
          textAlign: "center",
          padding: "8px",
          fontWeight: "bold",
          zIndex: 9999,
        }}
      >
        You’re offline.
      </div>
    );
  }

  if (showOnlineBanner) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: "#52c41a",
          color: "white",
          textAlign: "center",
          padding: "8px",
          fontWeight: "bold",
          zIndex: 9999,
        }}
      >
        Back online!
      </div>
    );
  }

  return null;
}
